import { render, staticRenderFns } from "./editcustomerinfo.vue?vue&type=template&id=d436ebd2&scoped=true"
import script from "./editcustomerinfo.vue?vue&type=script&lang=js"
export * from "./editcustomerinfo.vue?vue&type=script&lang=js"
import style0 from "./editcustomerinfo.vue?vue&type=style&index=0&id=d436ebd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d436ebd2",
  null
  
)

export default component.exports